import "../css/app.css";
import "./bootstrap";

import { createInertiaApp } from "@inertiajs/react";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { createRoot } from "react-dom/client";
import { router } from "@inertiajs/react";
import AppProvider from "./components/AppProvider";

// Configure CSRF token for Inertia requests
router.on("before", (event) => {
    const token = document.head
        .querySelector('meta[name="csrf-token"]')
        ?.getAttribute("content");
    if (token) {
        event.detail.visit.headers = {
            ...event.detail.visit.headers,
            "X-CSRF-TOKEN": token,
        };
    }
});

// Handle 419 CSRF errors globally
router.on("error", (event) => {
    const response = event.detail.response;

    // Check if it's a 419 CSRF error
    if (response && response.status === 419) {
        console.warn('419 CSRF error detected, reloading page...');

        // Show user-friendly message if toast is available
        if (typeof window !== 'undefined' && (window as any).toast) {
            (window as any).toast.error('Sesi keamanan telah berubah. Halaman akan dimuat ulang...');
        }

        // Reload the page after a short delay
        setTimeout(() => {
            window.location.reload();
        }, 1500);

        // Prevent default error handling
        event.preventDefault();
    }
});

const appName = import.meta.env.VITE_APP_NAME || "Laravel";

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: async (name) => {
        try {
            const page = await resolvePageComponent(
                `./pages/${name}.tsx`,
                import.meta.glob("./pages/**/*.tsx"),
            );
            return page;
        } catch (error) {
            console.error(`Failed to resolve page component: ${name}`, error);
            // Return a fallback component for missing pages
            return {
                default: () => (
                    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
                        <div className="max-w-md w-full space-y-8 text-center">
                            <h2 className="text-3xl font-bold text-gray-900 dark:text-white">
                                Halaman Tidak Ditemukan
                            </h2>
                            <p className="text-gray-600 dark:text-gray-400">
                                Halaman yang Anda cari tidak tersedia.
                            </p>
                            <a
                                href="/"
                                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-[#de0b66] hover:bg-[#de0b66]/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#de0b66]"
                            >
                                Kembali ke Beranda
                            </a>
                        </div>
                    </div>
                )
            };
        }
    },
    setup({ el, App, props }) {
        const root = createRoot(el);

        root.render(
            <AppProvider>
                <App {...props} />
            </AppProvider>,
        );
    },
    progress: {
        color: "#4B5563",
    },
});

// Theme initialization now handled by AppProvider

// Register Service Worker (production only)
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch((err) => {
      console.warn('SW registration failed:', err);
    });
  });
}

